// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".is-hidden{display:none}.has-spacing-top{margin-top:.5rem}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/geral/BotaoSolicitarAutos.vue"],"names":[],"mappings":"AACA,WACE,YAAF,CACA,iBACE,gBACF","sourcesContent":["\n.is-hidden\n  display none\n.has-spacing-top\n  margin-top 0.5rem\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
